import React from 'react';
import { Container } from 'reactstrap';
import { FixHeader } from '../components/common/fix-header/index';
import { SideMenu } from '../components/common/side-menu/index';

export const Layout = ({ children }) => {
  return (
    <>
      <div>
        <FixHeader />
        <div className='main-wrap'>
          <SideMenu />
          <Container fluid={true} tag="main">
            {children}
          </Container>
        </div>
      </div>
    </>
  )
}